export default __webpack_public_path__ + "static/media/icons8-traveler-100.a8d4b898.svg";